<template>
    <b-modal :visible="isOpen" @hide="close">

    <template #modal-header>
      <slot name="header">
        <h5>{{ modalTitle }}</h5>
        <b-button size="sm" @click="close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17.028"
            height="17.028"
            viewBox="0 0 17.028 17.028"
          >
            <path
              id="Icon_material-close"
              d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
              transform="translate(-7.5 -7.5)"
              fill="#393939"
            />
          </svg>
        </b-button>
      </slot>
    </template>
    <form>
      <div class="center">
        <b-form-group :label="$t('Type') + '*'">
          <b-form-select
            v-model="localUpdateData.type.$model"
            :options="optionsType"
            aria-describedby="type-feedback"
          ></b-form-select>
        </b-form-group>

        <b-form-group :label="$t('NAME') + '*'" label-for="nom">
          <b-form-input
            class="form-control"
            aria-required="true"
            :placeholder="$t('NAME')"
            id="nom"
            required
            :class="{
              'form-control is-invalid': !isNameValid,
              'form-control has-validation': isNameValid,
            }"
            v-model="localUpdateData.nom.$model"
            oninput="this.value = this.value.toUpperCase()"
            aria-describedby="nom-feedback"
          ></b-form-input>

          <div v-if="erreurlist.nom" class="error-message">
            <ul v-if="Array.isArray(erreurlist.nom)">
              <span v-for="(e, index) in erreurlist.nom" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.nom }}</span>
          </div>
        </b-form-group>

        <b-form-group :label="$t('SIRET') + '*'" label-for="siret">
          <b-form-input
            class="form-control"
            id="siret"
            :placeholder="$t('SIRET')"
            required
            :class="{
              'form-control is-invalid': !issiretValid,
              'form-control has-validation': issiretValid,
            }"
            v-model="localUpdateData.siret.$model"
            oninput="this.value = this.value.toUpperCase()"
            aria-describedby="siret-feedback"
          ></b-form-input>

          <div v-if="erreurlist.siret" class="error-message">
            <ul v-if="Array.isArray(erreurlist.siret)">
              <span v-for="(e, index) in erreurlist.siret" :key="index">
                {{ e }}
              </span>
            </ul>
            <span v-else>{{ erreurlist.siret }}</span>
          </div>
        </b-form-group>

        <b-form-group
          :label="$t('Terme et conditions') + ' ' + $t('MaPrimeRenov')"
          label-for="paragraphMaPrimeRenov"
        >
          <b-form-textarea
            class="form-control"
            :placeholder="$t('Terme et conditions') + ' ' + $t('MaPrimeRenov')"
            id="paragraphMaPrimeRenov"
            maxlength="1000000000000000000000000"
            rows="3000000000000"
            v-model="localUpdateData.paragraphMaPrimeRenov.$model"
            oninput="this.value = this.value.toUpperCase()"
            aria-describedby="paragraphMaPrimeRenov-feedback"
            :class="{
              'form-control is-invalid': erreurlist.paragraphMaPrimeRenov,
              'form-control has-validation': !erreurlist.paragraphMaPrimeRenov,
            }"
          ></b-form-textarea>
          <div v-if="erreurlist.paragraphMaPrimeRenov" class="error-message">
            <span>{{ erreurlist.paragraphMaPrimeRenov }}</span>
          </div>
        </b-form-group>

        <b-form-group
          :label="$t('Terme et conditions ') + ' ' + $t('CEE')"
          label-for="paragraphCEE"
        >
          <b-form-textarea
            maxlength="10000000000000000000000000"
            rows="30000000000"
            class="form-control"
            :placeholder="$t('Terme et conditions ') + ' ' + $t('CEE')"
            id="paragraphCEE"
            v-model="localUpdateData.paragraphCEE.$model"
            oninput="this.value = this.value.toUpperCase()"
            aria-describedby="paragraphCEE-feedback"
            :class="{
              'form-control is-invalid': erreurlist.paragraphCEE,
              'form-control has-validation': !erreurlist.paragraphCEE,
            }"
          ></b-form-textarea>
          <div v-if="erreurlist.paragraphCEE" class="error-message">
            <span>{{ erreurlist.paragraphCEE }}</span>
          </div>
        </b-form-group>

        <!-- Cartes pour les montants -->
        <div class="amount-cards-container">
          <b-card class="amount-card">
            <div class="amount-card-content">
              <div class="amount-label">{{ $t('Montant') }} {{ $t('CEE') }}</div>
              <div class="amount-value">
                <span class="amount-text">{{ montantPrimeCEE }}</span>
              </div>
              <b-button 
                variant="link" 
                class="copy-btn" 
                @click="copyPlaceholder('paragraphCEE')"
                :title="$t('Copy placeholder')"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
              </b-button>
            </div>
          </b-card>

          <b-card class="amount-card">
            <div class="amount-card-content">
              <div class="amount-label">{{ $t('Montant') }} {{ $t('MaPrimeRenov') }}</div>
              <div class="amount-value">
                <span class="amount-text">{{ montantANNAH }}</span>
              </div>
              <b-button 
                variant="link" 
                class="copy-btn" 
                @click="copyPlaceholder('paragraphMaPrimeRenov')"
                :title="$t('Copy placeholder')"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
              </b-button>
            </div>
          </b-card>
        </div>

        <b-form-group :label="$t('COMPANY_ID')" v-if="isSuperAdmin">
          <multiselect
            v-model="selectedEntreprise"
            :searchable="true"
            :close-on-select="true"
            :multiple="false"
            :options="getAllentreprises"
            label="lib"
            track-by="id"
            @select="updateEntrepriseId"
          >
            <div v-if="erreurlist.entreprise" class="error-message">
              <ul v-if="Array.isArray(erreurlist.entreprise)">
                <span v-for="(e, index) in erreurlist.entreprise" :key="index">
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.entreprise }}</span>
            </div>
            <template slot="noResult">
              {{ $t("NO_DATA_FOUND") }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group :label="$t('LOGO')">
          <div class="logoName" v-if="logo || previewLogo || (updateData && updateData.logo)">
            <div class="profil">
              <div class="newlog">
                <img v-if="previewLogo" :src="previewLogo" alt="logo" class="imgnew" />
                <img v-else-if="updateData && updateData.logo" :src="downloadUrl + updateData.logo" alt="logo" class="imgnew" />
              </div>
            </div>
          </div>
          <b-form-file
            v-model="logo"
            class="file_input"
            accept="image/*"
            @change="handleLogoChange"
            placeholder=""
            drop-placeholder=""
          ></b-form-file>
        </b-form-group>
      </div>
    </form>

    <template #modal-footer>
      <slot name="footer">
        <div class="double">
          <b-button variant="danger" @click="close">{{
            $t("CANCEL")
          }}</b-button>
          <b-button variant="success" @click="confirm">{{
            $t("SAVE")
          }}</b-button>
        </div>
      </slot>
    </template>
  </b-modal>
</template>
<script>
import { mapGetters } from "vuex";
import { handlePaste, preventExceedingLengthFloat } from '@/utils/inputUtils';
import { domains } from "@/environment"; 
export default {
  data() {
    return {
      localOpen: false,
      isNameValid: true,
      paragraphCEEValid: true,
      paragraphMaPrimeRenovValid: true,
      issiretValid: true,
      erreurlist: {
        nom: [],
        siret: [],
        entreprise: [],
        type: [],
        paragraphCEE: "",
        paragraphMaPrimeRenov: "",
      },
      selectedEntreprise: null,
      localUpdateData: {},
      logo: null,
      previewLogo: null,
      downloadUrl: domains.download,
      optionsType: [
        { value: "mandataire", text: this.$t("AGENT") },
        { value: "delegataire", text: this.$t("DELEGATAIRE") },
        { value: "oblige", text: this.$t("oblige") },
      ],
      montantPrimeCEE: "{{montantPrimeCEE}}",
      montantANNAH: "{{montantANNAH}}",
    };
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    updateData: {
      type: Object,
      default: () => null,
    },
    updateEntrepriseId:{
      type:Number,
      required:false
    }
  },
mounted() {
  console.log('🟢 modal monté');
}
,
  created() {
    this.initializeLocalUpdateData();
  },

 
  
  watch: {
    updateData: {
      immediate: true,
      handler() {
        this.initializeLocalUpdateData();
      },
    },
    "localUpdateData.nom.$model"(newValue) {
      this.validateName(newValue);
    },
    "localUpdateData.siret.$model"(newValue) {
      this.validateSiret(newValue);
    },
    // "localUpdateData.paragraphCEE.$model"(newValue) {
    //   this.validateParagraphCEE(newValue);
    // },

    "localUpdateData.paragraphCEE.$model"() {
      this.validateParagraphs();
    },
    "localUpdateData.paragraphMaPrimeRenov.$model"() {
      this.validateParagraphs();
    },
    isOpen(val) {
    if (val) {
      this.$nextTick(() => {
        this.$bvModal.show('mandataire-modal');
      });
    } else {
      this.$bvModal.hide('mandataire-modal');
    }
  }
  },

  methods: {
    onKeyDown(event) {
      preventExceedingLengthFloat(event);
    },
    
    onPaste(event, fieldName) {
      handlePaste.call(this, event, fieldName);
    },
    
    copyPlaceholder(fieldType) {
      let placeholderText = "";
      
      if (fieldType === "paragraphCEE") {
        placeholderText = this.montantPrimeCEE;
      } else if (fieldType === "paragraphMaPrimeRenov") {
        placeholderText = this.montantANNAH;
      }
      
      if (placeholderText) {
        // Copier dans le presse-papiers
        navigator.clipboard.writeText(placeholderText).then(() => {
          // Optionnel: afficher un message de confirmation
          this.$bvToast.toast(this.$t("Copied to clipboard"), {
            title: this.$t("Success"),
            variant: "success",
            solid: true,
            autoHideDelay: 2000,
          });
        }).catch(err => {
          console.error("Erreur lors de la copie:", err);
          // Fallback pour les navigateurs plus anciens
          const textArea = document.createElement("textarea");
          textArea.value = placeholderText;
          textArea.style.position = "fixed";
          textArea.style.left = "-999999px";
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand("copy");
            this.$bvToast.toast(this.$t("Copied to clipboard"), {
              title: this.$t("Success"),
              variant: "success",
              solid: true,
              autoHideDelay: 2000,
            });
          } catch (err) {
            console.error("Erreur lors de la copie (fallback):", err);
          }
          document.body.removeChild(textArea);
        });
      }
    },
    
    handleLogoChange(e) {
      if (!e.target.files || !e.target.files[0]) {
        this.logo = null;
        this.previewLogo = null;
        return;
      }
      
      const file = e.target.files[0];
      const fileSize = file.size;
      const maxSize = 2 * 1024 * 1024; // 2MB

      if (fileSize > maxSize) {
        this.$bvModal.msgBoxOk(
          this.$t("La taille du fichier dépasse la limite autorisée de 2 Mo"),
          {
            title: this.$t("ALERT"),
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          }
        );
        this.logo = null;
        this.previewLogo = null;
        return;
      }

      // Stocker le fichier dans this.logo pour l'envoyer avec FormData
      this.logo = file;
      this.previewLogo = URL.createObjectURL(file);
    },

    initializeLocalUpdateData() {
      this.localUpdateData = {
        type: {
          $model: (this.updateData && this.updateData.type) || "mandataire",
          $errors: [],
        },
        nom: {
          $model: (this.updateData && this.updateData.nom) || "",
          $errors: [],
        },
        siret: {
          $model: (this.updateData && this.updateData.siret) || "",
          $errors: [],
        },
        paragraphMaPrimeRenov: {
          $model:
            (this.updateData && this.updateData.paragraphMaPrimeRenov) || "",
          $errors: [],
        },
        paragraphCEE: {
          $model: (this.updateData && this.updateData.paragraphCEE) || "",
          $errors: [],
        },
        entreprise_id: {
          $model: (this.updateData && this.updateData.entreprise_id) || "",
          $errors: [],
        },
      };
      
      // Initialiser selectedEntreprise pour le mode édition
      if (this.updateData && this.updateData.entreprise_id && this.getAllentreprises) {
        this.selectedEntreprise = this.getAllentreprises.find(entreprise => entreprise.id === this.updateData.entreprise_id) || null;
      } else {
        this.selectedEntreprise = null;
      }
      
      // Reset logo file (we don't pre-populate it in edit mode, user needs to re-upload if they want to change)
      this.logo = null;
      this.previewLogo = null;
    },

    validateName(newValue) {
      if (!newValue || newValue.length < 1) {
        this.isNameValid = false;
        this.erreurlist.nom = ["Ce champ est obligatoire"];
      } else {
        this.isNameValid = true;
        this.erreurlist.nom = [];
      }
    },

    validateSiret(newValue) {
      if (!newValue) {
        this.issiretValid = false;
        this.erreurlist.siret = ["Ce champ est obligatoire"];
      } else if (newValue.length >= 9 && newValue.length <= 14) {
        this.issiretValid = true;
        this.erreurlist.siret = [];
      } else {
        this.issiretValid = false;
        this.erreurlist.siret = [
          "Le SIRET doit contenir entre 9 et 14 caractères.",
        ];
      }
    },

    validateParagraphs() {
      const hasParagraphCEE = this.localUpdateData.paragraphCEE.$model && this.localUpdateData.paragraphCEE.$model.trim().length > 0;
      const hasParagraphMaPrimeRenov = this.localUpdateData.paragraphMaPrimeRenov.$model && this.localUpdateData.paragraphMaPrimeRenov.$model.trim().length > 0;
      
      // Au moins un des deux paragraphes doit être rempli
      if (!hasParagraphCEE && !hasParagraphMaPrimeRenov) {
        this.paragraphCEEValid = false;
        this.paragraphMaPrimeRenovValid = false;
        this.erreurlist.paragraphCEE = "Au moins un des deux paragraphes (CEE ou Ma Prime Renov) est obligatoire";
        this.erreurlist.paragraphMaPrimeRenov = "Au moins un des deux paragraphes (CEE ou Ma Prime Renov) est obligatoire";
      } else {
        this.paragraphCEEValid = true;
        this.paragraphMaPrimeRenovValid = true;
        this.erreurlist.paragraphCEE = "";
        this.erreurlist.paragraphMaPrimeRenov = "";
      }
    },
    close() {
      // Reset logo when closing
      this.logo = null;
      this.previewLogo = null;
      this.$emit("update:isOpen", false); 
      this.$emit("close");
    },

    confirm() {
      this.validateName(this.localUpdateData.nom.$model);
      this.validateSiret(this.localUpdateData.siret.$model);
      this.validateParagraphs();
      
      if (
        !this.isNameValid ||
        !this.issiretValid ||
        !this.paragraphCEEValid ||
        !this.paragraphMaPrimeRenovValid
      ) {
        return;
      }

      if (this.selectedEntreprise) {
        this.localUpdateData.entreprise_id.$model = this.selectedEntreprise.id;
      } else {
        this.localUpdateData.entreprise_id.$model =
          this.getOnlineUser.entreprise.id;
      }

      // Récupérer le fichier logo de manière sécurisée
      let logoFile = null;
      if (this.logo) {
        if (this.logo instanceof File) {
          logoFile = this.logo;
        } else if (this.logo instanceof FileList && this.logo.length > 0) {
          logoFile = this.logo[0];
        } else if (Array.isArray(this.logo) && this.logo.length > 0) {
          logoFile = this.logo[0] instanceof File ? this.logo[0] : null;
        }
      }
      
      // Si un logo est présent et valide, utiliser FormData pour envoyer le fichier
      if (logoFile && logoFile instanceof File) {
        const bodyFormData = new FormData();
        bodyFormData.append("type", this.localUpdateData.type.$model);
        bodyFormData.append("nom", this.localUpdateData.nom.$model);
        bodyFormData.append("siret", this.localUpdateData.siret.$model);
        bodyFormData.append("paragraphCEE", this.localUpdateData.paragraphCEE.$model || "");
        bodyFormData.append("paragraphMaPrimeRenov", this.localUpdateData.paragraphMaPrimeRenov.$model || "");
        bodyFormData.append("entreprise_id", this.localUpdateData.entreprise_id.$model);
        bodyFormData.append("logo", logoFile);
        
        console.log('=== FORMDATA AVEC LOGO ===', {
          hasLogo: bodyFormData.has('logo'),
          logoName: logoFile.name,
          logoSize: logoFile.size
        });
        
        this.$emit("confirm", bodyFormData);
      } else {
        // Si pas de logo, envoyer un objet normal
        const confirmData = {
          type: this.localUpdateData.type.$model,
          nom: this.localUpdateData.nom.$model,
          siret: this.localUpdateData.siret.$model,
          paragraphCEE: this.localUpdateData.paragraphCEE.$model,
          paragraphMaPrimeRenov:
            this.localUpdateData.paragraphMaPrimeRenov.$model,
          entreprise_id: this.localUpdateData.entreprise_id.$model,
        };
        
        this.$emit("confirm", confirmData);
      }

      this.close();
    },
  },

  computed: {
    ...mapGetters(["getAllentreprises", "getOnlineUser"]),
    modalTitle() {
      return this.updateData && Object.keys(this.updateData).length > 0
        ? this.$t("EDIT")+" "+this.$t("ENTITE_EXTERNE")
        : this.$t("ADD")+" "+this.$t("ENTITE_EXTERNE");
    },
    isSuperAdmin() {
      return this.getOnlineUser.role === "user.super-admin";
    },
  },
};
</script>

<style lang="scss" scoped>
.option {
  display: flex;
  align-items: center;
  .option__image {
    background-color: #465081;
    padding: 4px;
    max-height: 42px;
    max-width: 42px;
  }
}

.logoName {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  
  .profil {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .newlog {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 91px;
    height: 91px;
    
    .imgnew {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background: #e9ecef;
      object-fit: cover;
    }
  }
}

.amount-cards-container {
  display: flex;
  gap: 0;
  margin-bottom: 0;
  flex-wrap: wrap;
  
  .amount-card {
    flex: 1;
    min-width: 180px;
    max-width: 220px;
    border: none;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    
    .amount-card-content {
      display: flex;
      flex-direction: column;
      padding: 0;
      position: relative;
      
      .amount-label {
        font-size: 12px;
        font-weight: 600;
        color: #6c757d;
        margin-bottom: 6px;
        padding: 0 2px;
      }
      
      .amount-value {
        display: flex;
        align-items: center;
        margin-bottom: 0;
        min-height: 32px;
        
        .amount-text {
          font-size: 14px;
          font-weight: 700;
          color: #212529;
          font-family: 'Courier New', monospace;
          background: #f8f9fa;
          padding: 6px 10px;
          border-radius: 5px;
          border: 1px solid #e9ecef;
          letter-spacing: 0.5px;
          flex: 1;
          word-break: break-all;
        }
      }
      
      .copy-btn {
        position: absolute;
        top: 0;
        right: 0;
        padding: 4px;
        color: #6c757d;
        border: none;
        background: transparent;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        
        &:hover {
          color: #007bff;
          background: #e7f3ff;
        }
        
        &:focus {
          outline: none;
        }
        
        svg {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
}
</style>
